import { Icon } from '@material-ui/core';
import Spin from 'components/Spin';
import QueryString from 'query-string';
import React from 'react';
import { connect } from 'react-redux';
import { changeConfirmationCoproducerStatus } from 'store/Orbita/Confirmation/actions';
import Footer from 'v2/components/Shared/Footer';

class Profile extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const urlParams = QueryString.parse(this.props.location.search);
    if (!urlParams.k || !urlParams.status) {
      this.props.history.push('/login');
    }
    (async () => {
      try {
        await this.props.dispatch(changeConfirmationCoproducerStatus(urlParams));
        setTimeout(() => this.props.history.push('/login'), 5000);
      } catch (error) {
        setTimeout(() => this.props.history.push('/login'), 5000);
      }
    })();
    this.setState({ status: urlParams.status === 'approved' ? 'Aprovado' : 'Reprovado' });
  }

  render() {
    return (
      <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', textAlign: 'center' }}>
        <div className='m32' />
        <div style={{ flex: 1 }}>
          {this.props.coproducer.isFetching && (
            <div>
              <Spin />
              <h2 style={{ color: '#596375' }}>Aguarde, salvando alterações...</h2>
            </div>
          )}
          {this.props.coproducer.error && (
            <div>
              <Icon style={{ fontSize: 48, color: '#dc3f53' }}>error_outline</Icon>
              <h2 style={{ color: '#dc3f53' }}>Link inválido</h2>
            </div>
          )}
          {!this.props.coproducer.isFetching && !this.props.coproducer.error && (
            <div>
              <Icon style={{ fontSize: 48, color: '#009358' }}>check_circle_outlin</Icon>
              <h2 style={{ color: '#009358' }}>{this.state.status} com sucesso</h2>
            </div>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}
const mapStateToProps = (state: any) => ({
  coproducer: state.orbita.Confirmation.confirmCoproducer,
});
export default connect(mapStateToProps)(Profile);
